import { useCurrentBreakPoint } from "telia-front-react";
const useIsMobileHook = () => {
  const currentBreak = useCurrentBreakPoint();
  const isMobile = currentBreak === "xs" || currentBreak === "sm";
  return { isMobile };
};
export {
  useIsMobileHook
};
